export interface DynamicConfig {
    apiUrl: string,
    environment: 'DEV' | 'TST' | 'ACK' | 'PROD',

    websiteApiUrl: string,

    defaultTenant: string,

    useReCAPTCHA: boolean,
    siteKeyReCAPTCHA: string,

    superUsers: string
}

export const defaultConfig : DynamicConfig = {
    //apiUrl: 'http://localhost/Welios',
    apiUrl: 'http://localhost:45073',
    environment: 'DEV',

    websiteApiUrl: 'https://skrapi.univ-soft.com',

    defaultTenant: 'univ',

    useReCAPTCHA: false,
    siteKeyReCAPTCHA: '',

    superUsers: '-0-1-'
}

class GlobalConfig {
    config: DynamicConfig = defaultConfig;
    notDefinedYet = true;

    public get() : DynamicConfig {
        if(this.notDefinedYet) {
            throw new Error(
                "Global config has been defined yet. Be sure "
            );
        } else {
            return this.config;
        }
    }

    public set(value : DynamicConfig) : void {
        if(this.notDefinedYet) {
            this.config = value;
            this.notDefinedYet = false;
        } else {
            throw new Error(
                "Global config has already been defined and now has been call second time. This is probably not intended."
            )
        }
    }
}


export const globalConfig = new GlobalConfig();

export const globalConfigUrl = 'config.json'